<template>
  <nav class="mb-5">
    <div class="d-flex justify-content-end align-items-center">
      <LocalizationBtn
        id="langBtn"
        label="locBtnLabel"
        :route="route"
        v-if="showLocalizationBtn === true"
      />
      <Cart
        class="d-flex justify-content-xl-end justify-content-end"
        v-if="showElements"
      />
    </div>
  </nav>

  <Stepper v-if="showElements" />

  <router-view />

  <devMenu v-if="developer" :route="route" style="margin-top: 250px" />

  <div style="display: none">
    <!--
  Developed by yourfutureacademy.nl,  
  
  Vue:	    TheDutchSean 
  JS:	    TheDutchSean,  shengx2, jobvank 
  Styling: 	shengx2, creativegibbs 
  @github.com 
  -->
  </div>

</template>
<script>
import Cart from "./components/Cart.vue";
import Stepper from "@/components/Stepper.vue";
import devMenu from "@/devtools/devMenu.vue";
import LocalizationBtn from "@/components/localization-dropdown.vue";
import localization from "@/scripts/localization.js";

// require("@/styles/global.css");

export default {
  name: "App",
  components: {
    Cart,
    devMenu,
    LocalizationBtn,
    Stepper,
  },
  data() {
    return {
      checkedPath: false,
      developer: false,
      outroVue: "",
      route: "App",
      selectedLang: "en",
      showElements: true,
      showLocalizationBtn: false,
      ready: false,
    };
  },
  computed: {},
  methods: {
    switchPath() {
      const lang = this.$Functions.getLangCode(this.$store.getters.getLang);

      if (this.$route.name !== undefined) {
        const selection = this.$Functions.getSelection(this.$route.name);
        this.$router.push({ name: `${lang}-${selection.code}` });
        return;
      } else {
        return;
      }
      // end switch path
    },
    checkPathLang() {
      let routes = this.$router.options.routes;
      for (const index in routes) {
        if (
          routes[index].name.toLowerCase() === this.$route.name.toLowerCase()
        ) {
          if (routes[index].lang !== this.$store.getters.getLang) {
            this.$store.commit("storeLang", routes[index].lang);
            break;
          }
        }
      }
      this.$store.commit("storeLocUpdate", true);

      // end checkPathLang
    },
    updateLang(selectedLang) {
      if (selectedLang !== undefined && selectedLang !== "") {
        localization.langSet("app", selectedLang, this.route);
        if (this.route !== undefined) {
          localization.langSet(this.route, selectedLang, this.route);
        }
      }
    },
    // end methods
  },
  beforeCreate() {
    this.$store.commit("initialiseCART");
  },
  created() {
    // set OTAP var
    if (this.$OTAP !== 3) {
      this.developer = false;
    }

    // alert if developer is enabled
    if (this.developer) {
      alert("Developer mode active !!");
    }

    // set default lang / get default from brower if not exist set englih to default
    for (let lang in this.languages) {
      if (lang.startsWith(localization.getBrowser())) {
        this.$store.commit("storeLang", lang);
        this.selectedLang = lang;
        break;
      } else {
        this.$store.commit("storeLang", "en");
        this.selectedLang = "en";
      }
    }
    this.updateLang();

    // get outro vue name
    this.outroVue = `${this.$Functions.getLangCode(
      this.$store.getters.getLang
    )}-${this.$RouteNames.outro}`;
  },
  mounted() { },
  beforeUpdate() {},
  updated() {
    this.ready = true;
  },
  watch: {
    "$route.name": function () {
      if (this.$route.name === this.outroVue) {
        this.showElements = false;
      } else {
        this.showElements = true;
      }

      this.checkPathLang();

      // enable LocalizationBtn
      if (!this.checkedPath && this.$route.path === "/") {
        this.showLocalizationBtn = true;
      }
      this.checkedPath = true;

      // set route for localization
      this.route = this.$route.matched[0].components.default.name;
      this.updateLang();
      // end watch route name
    },
    "$store.getters.getLang": function () {
      this.switchPath();

      if (this.ready) {
        this.route = this.$route.matched[0].components.default.name;
        this.updateLang();
      }
    },
    "$store.getters.getLocUpdate": function () {
      if (this.$store.getters.getLocUpdate) {
        this.updateLang(this.$store.getters.getLang);
        this.$store.commit("storeLocUpdate", false);
      }
    },
  },
};
</script>

<style lang=css>
 @import "./styles/global.css";
</style>